import React from 'react';
import PropTypes from 'prop-types';


const Logo = function LogoComponent({ href, title, image }) {
  if (href) {
    return (
      <a
        className="site-footer__logo-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="site-footer__logo-link-helper_text">
          {`Go to ${href}`}
        </span>
        <img
          className="site-footer__logo-img"
          src={image}
          alt={title}
        />
      </a>
    );
  }

  return (
    <img
      className="site-footer__logo-img"
      src={image}
      alt={title}
    />
  );
};


Logo.defaultProps = {
  href: '',
};
Logo.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default Logo;
